// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"8":"editor","88":"player","224":"register","685":"preview","962":"store"}[chunkId] || chunkId) + "." + {"8":"f301ec6a","88":"b98beaba","224":"68ce5ce0","486":"4f81a2ce","685":"b98beaba","962":"4465c352"}[chunkId] + ".chunk.css";
};